import React, { useState } from "react";

import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function ReportPostModal({ post, cancelModal }) {
  const { user } = useAuthContext();
  const [complete, setComplete] = useState(false);
  const [reason, setReason] = useState("");
  const [reasonErr, setReasonErr] = useState("");
  const [notes, setNotes] = useState("");
  const [notesErr, setNotesErr] = useState("");
  const [isLoading, setIsLoading] = useState(false);
//styled
  const handleReportPost = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    let err = false;

    if (reason === "empty" || reason.length === 0) {
      err = true;
      setReasonErr("Must select a reason");
    }

    if (notes.length === 0) {
      err = true;
      setNotesErr("Must fill in");
    }

    if (!err) {
      const createReportPost = {
        clubPostId: post.id,
        reason,
        notes,
      };

      try {
        const pinResponse = await axios.post(
          `${ApiConnectionString}/api/ReportPost`,
          createReportPost,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );

        if (pinResponse.status === 200) {
          setComplete(true);
        }
      } catch (error) {
        console.error("Failed to report the post:", error);
      } finally {
        setIsLoading(false); // Ensure loading state is reset
      }
    } else {
      setIsLoading(false); // Reset loading state if validation fails
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
        </div>
      </div>
    );
  } else {
    if (complete) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
          <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Post reported</p></div> 

<button
             type="button"
             className="close-button"
             onClick={cancelModal}
             aria-label="Close"
           >
             &times;
           </button>
           <p>The post report has been filed. Thank you.</p>


            <div className="send-modal-footer">
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Report Post</p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>
            <div>
              <div className="d-flex">
                {" "}
                <p className="red-text fw-bold"> {post.title}</p>{" "}
                <p className="text-muted mx-2">{post.createdDate.substring(0, 10)}</p>
              </div>

              <p>
                {post.content}
              </p>
            </div>

            <div>
              <div>
                <label htmlFor="reason">Reason for reporting:</label>
                <select
                  id="reason"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                >
                  <option value="empty">Select a reason</option>
                  <option value="spam">Spam</option>
                  <option value="abuse">Abuse</option>
                  <option value="harassment">Harassment</option>
                  <option value="other">Other</option>
                </select>
                {reasonErr && <p className="text-danger">{reasonErr}</p>}
              </div>
              <div>
                <label htmlFor="notes">Additional notes:</label>
                <textarea
                  id="notes"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                />
              </div>
              {notesErr && <p className="text-danger">{notesErr}</p>}
            </div>

            <div className="send-modal-footer">
              <button className="delete-button mx-3" onClick={handleReportPost}>
                Submit Report
              </button>
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
}
